import { useState, useEffect } from "react";
import { GroupInfo } from "../types/gigya";
import { GigyaGroupModels } from "../types/gigya.schema";

export const useGetAllMemberGroups = () => {
  const [loadingMemberGroups, setLoadingMemberGroups] = useState(true);
  const [memberGroupsError, setMemberGroupsError] = useState(false);
  const [memberGroups, setMemberGroups] = useState<
    Array<GroupInfo<GigyaGroupModels.ClinicModel>>
  >([]);

  useEffect(() => {
    window.gigya.accounts.groups.getAllMemberGroups({
      callback: (response) => {
        if (response.errorCode) {
          console.log("Error Details: ", response.errorDetails);
          setLoadingMemberGroups(true);
          setMemberGroupsError(true);
        } else {
          setMemberGroups(response.results);
          setLoadingMemberGroups(false);
          setMemberGroupsError(false);
        }
      },
    });

    return () => {
      setMemberGroups([]);
    };
  }, []);

  return {
    loadingMemberGroups,
    memberGroupsError,
    memberGroups,
    setMemberGroups,
  };
};
